<template>
  <main class="main page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="content">
            <div class="confirmation-redirect">
              <div class="confirmation-redirect__icon">
                <div class="spinner"></div>
              </div>
              <h1 class="confirmation-redirect__title">
                {{ $t(`Processing Confirmation`) }}
              </h1>
              <p class="confirmation-redirect__message">
                {{ $t(`We're confirming your transaction. Please wait...`) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "TransactionConfirmPage",
  created() {
    const orderId = this.$route.params.orderId;
    const token = this.$route.params.token;

    let apiUrl = process.env.VUE_APP_API;

    if (typeof apiUrl === "string" && apiUrl.endsWith("/")) {
      apiUrl = apiUrl.slice(0, -1);
    }
    const confirmUrl = `${apiUrl}/transaction/confirm/${orderId}/${token}`;

    window.location.href = confirmUrl;
  },
};
</script>

<style scoped>
.confirmation-redirect {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: #ffffff;
  border-radius: 16px;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.confirmation-redirect__icon {
  margin-bottom: 24px;
}

.confirmation-redirect__title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}

.confirmation-redirect__message {
  font-size: 16px;
  color: #64748b;
  margin-bottom: 24px;
  line-height: 1.5;
}

.spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  border: 4px solid rgba(140, 68, 174, 0.2);
  border-radius: 50%;
  border-top-color: #8c44ae;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 480px) {
  .confirmation-redirect {
    padding: 30px 16px;
  }

  .confirmation-redirect__title {
    font-size: 20px;
  }

  .confirmation-redirect__message {
    font-size: 14px;
  }
}
</style>
